import { toast } from "sonner";
import { api, errMsg, img, inr } from "@/lib/api";

export function Approvals({ products, reload }) {
  const pending = products.filter((p) => p.status === "pending");
  const act = async (p, approve) => {
    try {
      await api.post(`/admin/products/${p.id}/approve`, { approve });
      toast.success(approve ? "Approved - now live in store" : "Rejected");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div data-testid="approvals-panel">
      <h2 className="font-display text-xl mb-6">Waiting for approval <span className="text-[#6E6558] text-sm">({pending.length})</span></h2>
      {pending.length === 0 && <p className="text-[#6E6558] text-sm" data-testid="approvals-empty">Nothing waiting. All looms are in harmony.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {pending.map((p) => (
          <div key={p.id} className="rounded-sm border border-[#D4AF37]/15 bg-[#14110E] overflow-hidden" data-testid={`approval-card-${p.id}`}>
            <img src={img(p.image_url)} alt="" className="aspect-[4/3] w-full object-cover bg-[#0B0907]" />
            <div className="p-4">
              <p className="font-display text-sm">{p.name}</p>
              <p className="text-xs text-[#6E6558] mt-1">{p.origin} · {inr(p.price)} · by {p.created_by_name}</p>
              <p className="text-xs text-[#A89F91] mt-2 line-clamp-3">{p.description}</p>
              <div className="flex gap-2 mt-4">
                <button onClick={() => act(p, true)} className="flex-1 rounded-full bg-[#D4AF37] py-2 text-xs font-semibold text-[#0B0907]" data-testid={`approve-${p.id}`}>Approve</button>
                <button onClick={() => act(p, false)} className="flex-1 rounded-full border border-[#E06D3B]/50 py-2 text-xs text-[#E06D3B]" data-testid={`reject-${p.id}`}>Reject</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
